"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("@material-ui/core/styles");let b=a.makeStyles(a=>({phoneIcon:{marginRight:a.spacing(1)},phoneText:{marginRight:a.spacing(3)}}));exports.default=b
//# sourceMappingURL=styles.js.map
